import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import CopyWrapper from "components/Common/CopyWrapper";
import { COLOR_CASH_RECEIPT_TYPE, COLOR_GATEWAY_PAYMENT_METHOD, LIST_CASH_RECEIPT_TYPE_OPTION, LIST_GATEWAY_PAYMENT_METHOD_OPTION } from "helpers/constans";
import { formatDateStringToKorea, formatNumberWithCommas } from "helpers/format";

export default function TransactionDetails({
  item,
  handleClose
}: any) {
  const { t, i18n } = useTranslation();
  const dataFormat = item;
  
  const onCloseClick = () => {
    handleClose && handleClose();
  };

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={onCloseClick}>
        {t("Transaction details from Payment Gateway")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <Card>
          <CardBody>
            <Row>
              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="transactionId" className="form-label">
                    {t("Transaction ID")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.transactionId || ""}>
                      {`${dataFormat?.transactionId || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={8} lg={8}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="gwPGTransactionId" className="form-label">
                    {t("PG Transaction ID")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.gwPGTransactionId || ""}>
                      {`${dataFormat?.gwPGTransactionId || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dMxIssueNO" className="form-label">
                    {t("MxIssueNO")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dMxIssueNO || ""}>
                      {`${dataFormat?.dMxIssueNO || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dMxIssueDate" className="form-label">
                    {t("MxIssueDate")}
                  </Label>
                  
                  <div className="cursor-pointer text-gray">
                    {dataFormat?.dMxIssueDate ? formatDateStringToKorea(dataFormat?.dMxIssueDate) : "-"}
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dVactNo" className="form-label">
                    {t("VactNo")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dVactNo}>
                      {`${dataFormat?.dVactNo || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dRemitter" className="form-label">
                    {t("Remitter")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dRemitter}>
                      {`${dataFormat?.dRemitter || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="Amount" className="form-label">
                    {t("Amount")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dAmount}>
                      {`${formatNumberWithCommas(dataFormat?.dAmount) || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="Currency" className="form-label">
                    {t("Currency")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    {dataFormat?.currency === "KRW" ? "₩" : (dataFormat?.currency || "-")}
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="Payment Method" className="form-label">
                    {t("Payment Method")}
                  </Label>
                  <div>
                    {
                      dataFormat?.gatewayPaymentMethod ? (
                        <span
                          className={`rounded-pill badge bg-${
                            COLOR_GATEWAY_PAYMENT_METHOD[
                              dataFormat?.gatewayPaymentMethod
                            ] || "secondary"
                          }`}
                          style={{
                            fontSize: "0.8rem",
                            lineHeight: 1
                          }}
                        >
                          {t(
                            LIST_GATEWAY_PAYMENT_METHOD_OPTION?.find(
                              (item: any) =>
                                String(item?.value) ===
                                String(dataFormat?.gatewayPaymentMethod)
                            )?.label || ""
                          )}
                        </span>
                      ): "-"
                    }
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="field" className="form-label">
                    {t("Cash Receipt Type")}{" "}
                  </Label>
                  <div>
                    {
                      dataFormat?.dCashReceiptType ? (
                        <span
                          className={`rounded-pill badge bg-${
                            COLOR_CASH_RECEIPT_TYPE[
                              dataFormat?.dCashReceiptType
                            ] || "secondary"
                          }`}
                          style={{
                            fontSize: "0.8rem",
                            lineHeight: 1
                          }}
                        >
                          {t(
                            LIST_CASH_RECEIPT_TYPE_OPTION?.find(
                              (item: any) =>
                                String(item?.value) ===
                                String(dataFormat?.dCashReceiptType)
                            )?.label || ""
                          )}
                        </span>
                      ): "-"
                    }
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dCashYN" className="form-label">
                    {t("CashYN")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dCashYN}>
                      {`${dataFormat?.dCashYN || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>
              
              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dCashCardNO" className="form-label">
                    {t("CashCardNO")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dCashCardNO || ""}>
                      {`${dataFormat?.dCashCardNO || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>

              <Col md={4} lg={4}>
                <div className="mb-3 mt-2">
                  <Label htmlFor="dCashAuthNO" className="form-label">
                    {t("CashAuthNO")}
                  </Label>
                  <div className="cursor-pointer text-gray">
                    <CopyWrapper contentCopy={dataFormat?.dCashAuthNO}>
                      {`${dataFormat?.dCashAuthNO || "-"}`}
                    </CopyWrapper>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        
        </Card>
      </ModalBody>
    </Modal>
  );
}
